<template>
	<MonitorLayoutTemplate
        :table_title="table_title"
    >
        <template v-slot:datetime>
            <QpeDatetime
                :props_date="date"
                :props_time="time"
                :name="default_value"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>

        <template v-slot:description>
            <SignsCalculator 
                :data="sign_data"
            />
        </template>

        <template v-slot:signs>
            <MonitorSigns
                :data="sign_data"
                :hide_alert_remarks="true"
                :is_show_raw_html="true"
                sort_type="by_parent"
            />
        </template>
        
        <template v-slot:data_table="slot_props">
            <QpeDatatable
                class="lightning"
                :data="table_data"
                :headers="header"
                :name="default_value"
                :error_text="error_text"
                :props_date="date"
                :props_time="time"
                :search="slot_props.search"
                :should_show_raw_html_header="should_show_raw_html_header"
                :show_download_pdf_btn="true"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            >
                <template v-slot:table_description>
                    <div class="option-description">
                        燈號說明：<br>
                        <span class="description-dot" style="background: #FF0000"/>
                            <span> 0-3km有閃電發生 </span><br>
                        <span class="description-dot" style="background: #FF9900"/>
                            <span> 3-8km有閃電發生 </span><br>
                        <span class="description-dot" style="background: #FFFF00"/>
                            <span> 8-16km有閃電發生 </span><br>
                        <span>閃電資料來源：氣象署</span>
                    </div>
                </template>
            </QpeDatatable>
        </template>
    </MonitorLayoutTemplate>
</template>

<script>
    import { redirect_monitor_table_ajax } from "@/utils/monitor/monitor.js"
    import { monitor_signs_normal_mapping_css, monitor_signs_icon_name_mapping ,TABLE_VALUE_TEXT_MAPPING } from "@/config/monitor_config"
    import { monitor_mixin } from "@/utils/monitor/monitor_mixin.js"
    import cloneDeep from 'lodash/cloneDeep'
    import MonitorLayoutTemplate from "@/components/monitor/_tool/layout_template.vue"
    import QpeDatetime from "@/components/monitor/qpe_datetime.vue"
    import SignsCalculator from "@/components/monitor/_tool/signs_calculator.vue";
    import MonitorSigns from '@/components/monitor/_tool/monitor_signs.vue';
    import QpeDatatable from "@/components/monitor/qpe_datatable.vue";

	export default {
        name: 'caa_lightning',

        components: { 
            MonitorLayoutTemplate,
            QpeDatetime,
            SignsCalculator,
            MonitorSigns,
            QpeDatatable 
        },

        mixins: [monitor_mixin],
      
		data() {
			return {
                header: [],
                immutable_table_data: [],
                table_data: [],
                default_value: 234,
                error_text: '',

                should_show_raw_html_header: [
                    '雲對地閃電 0-3km', '雲對地閃電 3-8km', '雲對地閃電 8-16km', 
                    '雲間閃電 0-3km', '雲間閃電 3-8km', '雲間閃電 8-16km'
                ],
            }
        },

        computed: {
            table_title() {
                return `${TABLE_VALUE_TEXT_MAPPING[this.default_value]['tag_name']}資訊`
            },

            sign_data() {
                return this.reconstruct_alert_icon(this.immutable_table_data)
                    .map(datum => {
                        const alert_level_value = datum['lightning_distance_level']
                        const signs_num =  alert_level_value !== 4 ? this._get_color_dot_html(datum['lightning_distance_level']) : '-'
                        return {
                            idx: datum['機場名稱'],
                            signs_num
                        }
                    });
            },
        },
    
        created() {
            redirect_monitor_table_ajax.call(this, this.default_value)
        },

		methods: {
            generate_table_data (data, header) {
                this.immutable_table_data = data;
                this.table_data = this.reconstruct_alert_icon(data).sort(this.sorter_by_lightning_distance_level);
                this.header = header;
            },

            reconstruct_alert_icon(table_contents) {
                const new_alert_content = table_contents.map(content => {
                    const new_content = this.should_show_raw_html_header.reduce((accumulator, html_header) => {
                        const alert_level_value = content[html_header]
                        const signal_class = monitor_signs_normal_mapping_css[alert_level_value]
                        if(!signal_class) return accumulator 
                        
                        const is_upgrade_alert_level = +alert_level_value < accumulator['lightning_distance_level']

                        return {
                            ...accumulator,
                            [html_header]: [{
                                'html': this._get_color_dot_html(alert_level_value),
                            }],
                            'lightning_distance_level': is_upgrade_alert_level ? alert_level_value : accumulator['lightning_distance_level']
                        }
                    }, { 'lightning_distance_level': 4 })

                    return { ...content, ...new_content }
                })

                return new_alert_content
            },

            sorter_by_lightning_distance_level(prev, next) {
                return prev['lightning_distance_level'] - next['lightning_distance_level']
            },

            _get_color_dot_html(alert_level_value) {
                const signal_class = monitor_signs_normal_mapping_css[alert_level_value]
                const icon_class = monitor_signs_icon_name_mapping[alert_level_value]
                return `<i class="v-icon ${icon_class} ${signal_class}"></i>`
            }  
        },
	}
</script>
